module.exports = __webpack_public_path__ + "static/media/slider_5_en.5128b00a.svg";